<template>
    <h1>404 - page not found</h1>
</template>

<script>

import { mapMutations } from 'vuex'

export default {

    created() {

    },

    mounted() {
        this.setLoading(false)
    },

    methods: {
        ...mapMutations([
                'setLoading',
            ]),
    },

    data () {
        return {

        }
    },
}
</script>

<style scoped>


</style>